import { createContext, useContext } from "react"
import type { LanguageContextValue } from "./LanguageProvider"

export const LanguageContext = createContext<LanguageContextValue | null>(null)

export const useLanguage = () => {
  const context = useContext(LanguageContext)

  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider")
  }

  return context
}
